import Main from './components/Main'

export default [
  { path: '/dashboard', component: Main, name: 'dashboard.main' }
]



// WEBPACK FOOTER //
// ./src/app/dashboard/routes.js